module.exports = __webpack_public_path__ + "img/rank-3-bg.5ba67278.png";